export const ROLE_CURATOR = 'curator';
export const ROLE_SUBMITTER = 'keyworder';
export const ROLE_REVIEWER = 'reviewer';
export const ROLE_RANKER = 'ranker';
export const ROLE_BUSINESS = 'business';
export const ROLE_CREATOR = 'creator';
export const ROLE_ADMIN = 'admin';
export const ROLE_CHALLENGE_ADMIN = 'Wirestock/Marketing/ChallengesAdministrator';
export const SELECTED_ROLE = 'SELECTED_ROLE';
